import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from '@material-ui/core/Typography';
import {MilestoneStatus} from '../utils/constants';

const useStyles = makeStyles(() => ({
    summaryHeader: {
        flexGrow: '1',
        fontSize: '24px',
        lineHeight: '28px',
    },
    summarySubheader: {
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'right',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end'
    },
    headerRow: {
        display: 'flex',
        flexGrow: 1
    },
    simpleDiv100Percent: {
        width: '100%'
    }
}));

const IconButton = ({icon, onClick}) => {
    return (
        <Button onClick={(e) => { e.stopPropagation(); onClick(e); }} >
            {icon}
        </Button>
    );
}

const getGiftBox = () => {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '1rem'}}>
          <g id="card_giftcard_24px">
              <path id="icon/action/card_giftcard_24px" fillRule="evenodd" clipRule="evenodd" d="M21.6 5.05263H18.984C19.116 4.66105 19.2 4.23158 19.2 3.78947C19.2 1.69263 17.592 0 15.6 0C14.34 0 13.248 0.682105 12.6 1.70526L12 2.55158L11.4 1.69263C10.752 0.682105 9.66 0 8.4 0C6.408 0 4.8 1.69263 4.8 3.78947C4.8 4.23158 4.884 4.66105 5.016 5.05263H2.4C1.068 5.05263 0.012 6.17684 0.012 7.57895L0 21.4737C0 22.8758 1.068 24 2.4 24H21.6C22.932 24 24 22.8758 24 21.4737V7.57895C24 6.17684 22.932 5.05263 21.6 5.05263ZM15.5999 2.52632C16.2599 2.52632 16.7999 3.09474 16.7999 3.78947C16.7999 4.48421 16.2599 5.05263 15.5999 5.05263C14.9399 5.05263 14.3999 4.48421 14.3999 3.78947C14.3999 3.09474 14.9399 2.52632 15.5999 2.52632ZM9.60019 3.78947C9.60019 3.09474 9.06019 2.52632 8.4002 2.52632C7.7402 2.52632 7.2002 3.09474 7.2002 3.78947C7.2002 4.48421 7.7402 5.05263 8.4002 5.05263C9.06019 5.05263 9.60019 4.48421 9.60019 3.78947ZM21.5999 18.9474V21.4737H2.3999V18.9474H21.5999ZM2.3999 7.57895V15.1579H21.5999V7.57895H15.5039L17.9999 11.1537L16.0559 12.6316L11.9999 6.82105L7.9439 12.6316L5.9999 11.1537L8.4959 7.57895H2.3999Z" fill="black" fillOpacity="0.54"/>
          </g>
      </svg>);
};

const getStatus = (status) => {
    if (!status) {
        return '';
    }
    return (MilestoneStatus.find(item => item.value === status)).label;
};

export default function ExpansionCard({ header, subheader, detailsCard, activeIcon, onClickActiveIcon,
                                          isDelivery = false, milestone, isStakeholder= false}) {
    const [ isExpanded, setExpanded ] = useState(false);
    const classes = useStyles();

    const toggleExpanded = () => setExpanded(!isExpanded);
    return (
        <ExpansionPanel expanded={isStakeholder ? true : isExpanded}>
            <ExpansionPanelSummary onClick={toggleExpanded} expandIcon={isStakeholder ? '' : <ExpandMoreIcon />}>
                <div className={classes.simpleDiv100Percent}>
                    <div className={classes.headerRow}>
                        {isDelivery ? getGiftBox() : ''}
                        <Typography className={classes.summaryHeader}>
                            {!isStakeholder ? milestone.id + ': '+ header : header}
                        </Typography>
                        <Typography className={classes.summarySubheader}>
                            {isExpanded && activeIcon ? <IconButton onClick={onClickActiveIcon} icon={activeIcon} /> : subheader }
                        </Typography>
                    </div>
                    <div className={classes.headerRow}>
                        <Typography className={classes.summaryHeader}>
                            {milestone.owner}
                        </Typography>
                        {!isStakeholder ? (<Typography className={classes.summarySubheader}>
                            {getStatus(milestone.status)}
                        </Typography>) :
                        ''}
                    </div>
                </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                {detailsCard}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}
